class FacetFiltersForm extends HTMLElement {
  constructor() {
    super()
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this)

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event)
    }, 500)

    const facetForm = this.querySelector('form')
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this))

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop')
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape)

    const toggleFilterBtn = facetForm.querySelector('[data-toggle-filter]')
    if (toggleFilterBtn) toggleFilterBtn.addEventListener('click', this.onToggleFilterClick.bind(this))
  }

  onToggleFilterClick(event) {
    const filters = this.parentNode.querySelector('#main-collection-filters')
    if (!filters) return

    const button = event.currentTarget
    button.classList.toggle('filters-on')
    filters.classList.toggle('expanded')
    document.querySelector('.product-grid-container').classList.toggle('expanded')

    const toggleFilterBtnText = button.querySelector('[data-toggle-filter-text]')
    toggleFilterBtnText.textContent === window.variantStrings.showFilters
      ? (toggleFilterBtnText.textContent = window.variantStrings.hideFilters)
      : (toggleFilterBtnText.textContent = window.variantStrings.showFilters)
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial
      if (searchParams === FacetFiltersForm.searchParamsPrev) return
      FacetFiltersForm.renderPage(searchParams, null, false)
    }
    window.addEventListener('popstate', onHistoryChange)
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable)
    })
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams
    const sections = FacetFiltersForm.getSections()
    const countContainer = document.getElementById('ProductCount')
    const countContainerDesktop = document.getElementById('ProductCountDesktop')
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading')
    if (countContainer) {
      countContainer.classList.add('loading')
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading')
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`
      const filterDataUrl = (element) => element.url === url

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event)
    })

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams)
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }]
        FacetFiltersForm.renderFilters(html, event)
        FacetFiltersForm.renderProductGridContainer(html)
        FacetFiltersForm.renderProductCount(html)
      })
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html
    FacetFiltersForm.renderFilters(html, event)
    FacetFiltersForm.renderProductGridContainer(html)
    FacetFiltersForm.renderProductCount(html)
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount')
    const containerDesktop = document.getElementById('ProductCountDesktop')
    container.innerHTML = count
    container.classList.remove('loading')
    if (containerDesktop) {
      containerDesktop.innerHTML = count
      containerDesktop.classList.remove('loading')
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html')

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    )
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false
    }
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element))
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex)

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML
    })

    FacetFiltersForm.renderActiveFacets(parsedHTML)
    FacetFiltersForm.renderAdditionalElements(parsedHTML)

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'))
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      '.active-facets-mobile',
      '.active-facets-desktop',
      '.active-facets-mobile-modal',
    ]

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector)
      if (!activeFacetsElement) return
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML
    })

    FacetFiltersForm.toggleActiveFacets(false)
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting']

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML
    })
    if (!document.getElementById('FacetFiltersFormMobile')) return
    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents()
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected')
    const sourceElement = source.querySelector('.facets__selected')

    const targetElementAccessibility = target.querySelector('.facets__summary')
    const sourceElementAccessibility = source.querySelector('.facets__summary')

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`)
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form)
    return new URLSearchParams(formData).toString()
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event)
  }

  onSubmitHandler(event) {
    event.preventDefault()
    const sortFilterForms = document.querySelectorAll('facet-filters-form form')
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = []
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile'

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list')
            noJsElements.forEach((el) => el.remove())
            forms.push(this.createSearchParams(form))
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form))
        }
      })
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault()
    FacetFiltersForm.toggleActiveFacets()
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1)
    FacetFiltersForm.renderPage(url)
  }
}

FacetFiltersForm.filterData = []
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)
customElements.define('facet-filters-form', FacetFiltersForm)
FacetFiltersForm.setListeners()

class PriceRange extends HTMLElement {
  constructor() {
    super()
    // this.querySelectorAll('input').forEach((element) =>
    //   element.addEventListener('change', this.onRangeChange.bind(this))
    // )

    const el = this.querySelector('#price-filter')
    if (!el) return

    const self = this
    self.MAX = parseInt(el.dataset.max, 10)
    self.rangeMin = this.querySelector('#rangeMin')
    self.rangeMax = this.querySelector('#rangeMax')
    self.fill = this.querySelector('#sliderFill')
    self.dispMin = this.querySelector('#priceDisplayMin')
    self.dispMax = this.querySelector('#priceDisplayMax')
    self.setMinAndMaxValues()
    self.setupEventListeners()
    self.syncHighlight(parseInt(self.rangeMin.value, 10), parseInt(self.rangeMax.value, 10))
  }

  fmt(n) {
    if (n >= 1000) return '$' + (n / 1000).toFixed(n % 1000 === 0 ? 0 : 1) + 'k'
    return '$' + n.toLocaleString()
  }

  updateFill(min, max) {
    const lo = parseInt(min, 10)
    const hi = parseInt(max, 10)
    this.dispMin.textContent = lo.toLocaleString()
    this.dispMax.textContent = hi.toLocaleString()
  }

  deselectAll() {
    this.querySelectorAll('.price-filter__option').forEach(function (opt) {
      opt.classList.remove('price-filter__option--selected')
      opt.querySelector('.price-filter__radio-input').checked = false
    })
  }

  syncHighlight(lo, hi) {
    this.querySelectorAll('.price-filter__option').forEach(function (opt) {
      if (parseInt(opt.dataset.min, 10) === lo && parseInt(opt.dataset.max, 10) === hi) {
        opt.classList.add('price-filter__option--selected')
        opt.querySelector('.price-filter__radio-input').checked = true
      }
    })
  }

  onSliderInput(that) {
    return function () {
      const self = this
      let lo = parseInt(that.rangeMin.value, 10)
      let hi = parseInt(that.rangeMax.value, 10)

      that.rangeMin.setAttribute('value', lo)
      that.rangeMax.setAttribute('value', hi)

      that.updateFill(lo, hi)
      that.deselectAll()
      that.syncHighlight(lo, hi)
    }
  }

  setupEventListeners() {
    this.rangeMin.addEventListener('input', this.onSliderInput(this))
    this.rangeMax.addEventListener('input', this.onSliderInput(this))
    const url = new URL(window.location.href)
    const self = this
    this.querySelectorAll('.price-filter__option').forEach(function (opt) {
      opt.addEventListener('click', function () {
        self.deselectAll()
        opt.classList.add('price-filter__option--selected')
        opt.querySelector('.price-filter__radio-input').checked = true

        self.rangeMin.value = opt.dataset.min
        self.rangeMax.value = opt.dataset.max
        self.rangeMin.setAttribute('value', opt.dataset.min)
        self.rangeMax.setAttribute('value', opt.dataset.max)
        self.updateFill(opt.dataset.min, opt.dataset.max)
      })
    })
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget)
    this.setMinAndMaxValues()
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input')
    const minInput = inputs[0]
    const maxInput = inputs[1]
    if (maxInput.value) minInput.setAttribute('max', maxInput.value)
    if (minInput.value) maxInput.setAttribute('min', minInput.value)
    if (minInput.value === '') maxInput.setAttribute('min', 0)
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'))
  }

  adjustToValidValues(input) {
    const value = Number(input.value)
    const min = Number(input.getAttribute('min'))
    const max = Number(input.getAttribute('max'))

    if (value < min) input.value = min
    if (value > max) input.value = max
  }
}

customElements.define('price-range', PriceRange)

class FacetRemove extends HTMLElement {
  constructor() {
    super()
    const facetLink = this.querySelector('a')
    facetLink.setAttribute('role', 'button')
    facetLink.addEventListener('click', this.closeFilter.bind(this))
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault()
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event)
    })
  }

  closeFilter(event) {
    event.preventDefault()
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form')
    form.onActiveFilterClick(event)
  }
}

customElements.define('facet-remove', FacetRemove)

class NormalizedSizeFilter extends HTMLElement {
  connectedCallback() {
    const filter = JSON.parse(this.dataset.filter)
    const paramName = this.dataset.paramName

    const normalizedMap = this.normalize(filter)

    this.innerHTML = this.render(normalizedMap, paramName)
    this.attachEvents(normalizedMap, paramName)
  }

  normalize(values) {
    const map = {}

    values.forEach((v) => {
      const base = v.label.split('(')[0].trim()

      if (!map[base]) {
        map[base] = {
          label: base,
          values: [],
          valueSet: new Set(), // <-- track uniqueness
          count: 0,
          active: false,
          name: v.name,
        }
      }

      // Only add if value not already seen
      if (!map[base].valueSet.has(v.value)) {
        map[base].values.push(v)
        map[base].valueSet.add(v.value)
        map[base].count += v.count
      }

      if (v.active) {
        map[base].active = true
      }
    })

    // Optional: remove valueSet before returning (cleaner object)
    Object.values(map).forEach((group) => delete group.valueSet)
    return map
  }

  render(map, paramName) {
    const entries = Object.values(map)
    console.log('MAP__', map)
    return `
      <ul class="list-unstyled no-js-hidden" role="list">
        ${entries
          .map(
            (item, index) => `
          <li class="list-menu__item facets__item">
            <label class="facet-checkbox ${item.count === 0 && !item.active ? 'facet-checkbox--disabled' : ''}">

              <input
                type="checkbox"
                data-group="${item.label}"
                value="${item.values.map((value) => value.value)[0]}"
                name="${item.name}"
                ${item.active ? 'checked' : ''}
                ${item.count === 0 && !item.active ? 'disabled' : ''}
              >

              <svg width="2rem" height="2rem" viewBox="0 0 20 20">
                <rect width="20" height="20" stroke="currentColor" fill="none" stroke-width="1"></rect>
              </svg>

              <svg class="icon icon-checkmark" viewBox="0 0 14 10">
                <path d="M5.16942 7.69607L12.2405 0.625L13.1244 1.50888L5.16942 9.46383L0.75 5.04442L1.63388 4.16053Z"
                  fill="currentColor"/>
              </svg>

              <span class="caption">
                ${item.label}
                <span class="visually-hidden">(${item.count})</span>
              </span>

            </label>
          </li>
        `
          )
          .join('')}
      </ul>
    `
  }

  attachEvents(map, paramName) {
    this.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.addEventListener('change', (e) => {
        const group = e.target.dataset.group
        const values = map[group].values

        this.applyFilter(values, paramName, e.target.checked)
      })
    })
  }

  // applyFilter(values, paramName, isChecked) {
  //   const url = new URL(window.location.href)
  //   const params = url.searchParams

  //   // Remove existing params for this filter
  //   params.delete(paramName)

  //   if (isChecked) {
  //     values.forEach((v) => {
  //       params.append(paramName, v.value)
  //     })
  //   }

  //   window.location.href = url.toString()
  // }
}

customElements.define('normalized-size-filter', NormalizedSizeFilter)

document.querySelector('#SortBy-mobile').addEventListener('change', function (event) {
  const mobileFilterForm = document.getElementById('FacetFiltersFormMobile')
  if (!mobileFilterForm) {
    console.log('redirect instead')
    window.location = `${this.dataset.collection}?sort_by=${this.value}`
  } else {
    const sortField = mobileFilterForm.querySelector('[name="sort_by"]')
    if (!sortField) return
    sortField.value = this.value
    mobileFilterForm.submit()
  }
})
